import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { SocialFollow } from "../../basic/social-follow/social-follow";
import { CustomLink } from "../../custom-link";
import "./footer-template-two/footer-two.module.css";
import { Menu } from "./menu";
function getMenuData(menu, menuGroup) {
  const filteredMenu = menu.filter(item => item["menu-group-slug"] === menuGroup);
  return filteredMenu;
}

export const SocialFollowWrapper = props => {
  const { socialFollowStyle, socialLinks, publisherTheme, customCssClasses = "" } = props;

  return (
    <SocialFollow
      hasBackground={true}
      socialStyle={socialFollowStyle}
      socialLinks={socialLinks}
      color={publisherTheme["footer-text-color"] || "#000"}
      customCssClasses={customCssClasses}
    />
  );
};
SocialFollowWrapper.propTypes = {
  socialLinks: PropTypes.object,
  customCssClasses: PropTypes.string,
  publisherTheme: PropTypes.object,
  socialStyle: PropTypes.string,
  socialFollowStyle: PropTypes.string
};

export const SubscribeButton = props => {
  const { enableAccesstype } = props;
  return (
    enableAccesstype && (
      <a href="/subscription">
        <button styleName="subscribe-button" data-test-id="footer-subscribe">
          Subscribe
        </button>
      </a>
    )
  );
};

SubscribeButton.propTypes = {
  enableAccesstype: PropTypes.bool
};

export const Monogram = props => {
  const footerLogoUrl = get(props, ["footerLogoUrl"], "");
  return (
    <div id="monogram">
      {
        <CustomLink href="/">
          {footerLogoUrl ? (
            <img styleName="logo" src={footerLogoUrl} alt={props.publisherName} />
          ) : (
            <img styleName="logo" />
          )}
        </CustomLink>
      }
    </div>
  );
};
Monogram.propTypes = {
  publisherName: PropTypes.string
};

export const DefaultMenu = ({ menu, publisherTheme, closeAll, customCssClasses = "" }) => (
  <Menu
    styleName="menu"
    menu={getMenuData(menu, "footer-site-links")}
    languageDirection={get(publisherTheme, ["language_direction"], "left")}
    count={publisherTheme["primary_menu_count"] || 6}
    closeAll={closeAll}
    customCssClasses={customCssClasses}
  />
);
DefaultMenu.propTypes = {
  menu: PropTypes.object,
  closeAll: PropTypes.func,
  customCssClasses: PropTypes.string,
  publisherTheme: PropTypes.object,
  publisherName: PropTypes.string
};
